import { IBillingAddressInput } from 'generated/rbi-graphql';
import { PaymentISOs } from 'utils/form/constants';
import { IFraudPreventionValues } from 'utils/payment';

// @TODO This will be generated from Sanity
export type CardType = 'AMEX' | 'DINERS_CLUB' | 'DISCOVER' | 'JCB' | 'MASTERCARD' | 'VISA';

/**
 * @TODO This can be removed in favor of the generated `CartPaymentCardType` enum
 */
export enum CardTypes {
  AMEX = 'AMEX',
  APPLE_PAY = 'APPLE_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
  DINERS_CLUB = 'DINERS_CLUB',
  DISCOVER = 'DISCOVER',
  JCB = 'JCB',
  MASTERCARD = 'MASTERCARD',
  PAYPAL = 'PAYPAL',
  VISA = 'VISA',
}

/**
 * These card types are the ones supported by our Apple Pay plugin (frontend/ios/App/App/ApplePayPlugin.swift)
 */
export enum ApplePayCardTypes {
  AMEX = 'AmEx',
  DISCOVER = 'Discover',
  MASTERCARD = 'MasterCard',
  VISA = 'Visa',
}

export enum PaymentType {
  CASH = 'CASH',
  DIGITAL = 'DIGITAL',
  GIFT = 'GIFT',
}

export enum PaymentProcessor {
  ADYEN = 'ADYEN',
  FIRSTDATA = 'FIRSTDATA',
}

export interface ICredit {
  alias: string;
  /**
   * The BE does not currently standardize card type, for example upper case vs lower case.
   * Eventually we want to align the FE and BE.
   *
   * TODO: Use type from `IUserAccountsQuery` and not force our own.
   */
  cardType: CardTypes | string;
  expiryMonth: string;
  expiryYear: string;
  panToken: string;
}

export interface IPrepaid {
  alias: string;
  cardNumber: string;
  currentBalance: number;
  expiryMonth: string;
  expiryYear: string;
  feFormattedCurrentBalance: number | null;
  shuffledCardNumber: string;
}

export interface IPaymentMethod {
  accountIdentifier: string | null;
  fdAccountId: string | null;
  chaseProfileId: string | null;
  credit: ICredit | null;
  selected?: boolean;
  prepaid: IPrepaid | null;
  // make cash required eventually
  cash?: boolean | null;
}

export interface IAddAccount {
  addAccount: IPaymentMethod;
}

export interface IAddress {
  locality: string;
  postalCode: string;
  region: string;
  streetAddress: string;
  unitNumber?: string;
}

export interface IAddPaymentMethodOptions {
  skipErrorDialogOnError?: boolean;
}

export interface IDeleteAccount {
  deleteAccount: boolean;
}

export interface IGetAccounts {
  userAccounts?: {
    count?: number;
    accounts?: IPaymentMethod[];
  };
}

// @todo validate type
export interface IGetNonce {
  token: {
    tokenId: string;
  };
}

export interface IApplePayDetails {
  signature: string;
  applicationData: string;
  country: PaymentISOs;
  data: string;
  decryptAlias: string;
  ephemeralPublicKey: string;
  formatted: string;
  paymentData: string;
  primary: boolean;
  publicKeyHash: string;
  transactionId: string;
  type: string;
  version: string;
  billingAddress: IBillingAddressInput;
  PaymentMethodData?: IPaymentMethodData;
}

export interface IGooglePayDetails {
  signature: string;
  country: PaymentISOs;
  data: string;
  formatted: string;
  primary: boolean;
  type: string;
  version: string;
  billingAddress: IBillingAddressInput;
  PaymentMethodData?: IPaymentMethodData;
  paymentData: string;
}

interface IPaymentMethodData {
  paymentType: string;
  displayName: string;
}

export interface IReloadPrepaidCard {
  countryCode: string;
  fundValue: number;
  prepaidBalance: number;
  fdAccountId?: string | null;
  prepaidFdAccountId?: string | null;
  currencyCode?: string;
  cardType?: string | null;
  applePayDetails?: IApplePayDetails;
  googlePayDetails?: IGooglePayDetails;
}

export interface IReloadPrepaidCardConfig {
  swallowError?: boolean;
}

export interface IReloadDetails {
  prepaidsReload: {
    currentBalance: number;
    fdAccountId: string;
    fdCorrelationId: string;
    transactionId: string;
  };
}

export interface IPaymentDetails {
  accountIdentifier?: string;
  encryptedCN?: string;
  encryptedEM?: string;
  encryptedEY?: string;
  encryptedSC?: string;
  fdAccessToken?: string;
  fdNonce?: string;
  creditType?: string;
  fraudPreventionValues?: IFraudPreventionValues;
  applePayDetails?: IApplePayDetails;
  googlePayDetails?: IGooglePayDetails;
  saveCard?: boolean;
}
